import React from 'react';

const SIZES = {
  sm: { logo: 'h-8', mark: 'h-7', wm: 'text-base', tag: 'text-[8px]' },
  md: { logo: 'h-10', mark: 'h-9', wm: 'text-xl', tag: 'text-[9px]' },
  lg: { logo: 'h-12', mark: 'h-11', wm: 'text-2xl', tag: 'text-[10px]' },
  xl: { logo: 'h-16', mark: 'h-14', wm: 'text-3xl', tag: 'text-xs' },
};

export const Logo = ({ size = 'md', dark = false, className = '', variant = 'full' }) => {
  const s = SIZES[size] || SIZES.md;
  const inkColor = dark ? 'text-white' : 'text-[hsl(222_47%_11%)]';
  const tagColor = dark ? 'text-white/60' : 'text-muted-foreground';

  if (variant === 'mark') {
    return (
      <div className={`flex items-center ${className}`} data-testid="site-logo">
        <img src="/brand/alofi-mark.svg" alt="ALOFI SA" className={`${s.mark} w-auto`} draggable={false} />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="site-logo">
      <img src="/brand/alofi-mark.svg" alt="" aria-hidden="true" className={`${s.mark} w-auto`} draggable={false} />
      <div className="flex flex-col leading-none">
        <div className={`font-heading font-semibold tracking-[0.04em] ${s.wm} ${inkColor} flex items-baseline gap-1.5`}>
          <span>ALOFI</span>
          <span className="w-1.5 h-1.5 rounded-full bg-[hsl(186_55%_38%)] inline-block self-center" />
          <span>SA</span>
        </div>
        <div className={`hidden sm:block ${s.tag} mt-1 uppercase tracking-[0.18em] font-medium ${tagColor}`}>
          Grossiste · Intermarché
        </div>
      </div>
    </div>
  );
};
